import {
  FC,
  useEffect,
  useState
} from 'react';
import { CodeEditor, CodeEditorLanguage } from '@app/form_components';
import { useDesign } from '@app/hooks';
import { VersionSelector } from '@app/page-components';
import { Design } from '@app/types';

export const SettingsCcxmlPage: FC = () => {
  const serialized = useDesign();
  const [compareSerialized, setCompareSerialized] = useState<Design | null>(null);

  useEffect(() => {
    setCompareSerialized(null);
  }, [serialized.version]);

  return (
    <div className="modal-inner">
      <p>
        <strong>Note:</strong> If a copy of the CCXML file exists on-disk
        (/usr/local/iact/process-engine/ccxmlFiles/..../app.ccxml),
        the Process Engine prefers this copy of the file to the CCXML file included in the application itself.
        Make sure that these files are not stored locally to ensure the Process Engine uses the CCXML in the application.
      </p>
      <div className="flex-column flex-gap">
        <VersionSelector
          branchId={serialized.branchId}
          fieldConfig={{ className: 'z-over-code-editor' }}
          isClearable
          label="Compare Against:"
          name="compareVersion"
          onChange={(_, option) => setCompareSerialized(option?.serialized ?? null)}
          value={compareSerialized?.version ?? null}
        />
        <div style={{ height: '70vh' }}>
          <CodeEditor
            language={CodeEditorLanguage.xml}
            onChange={(newValue) => {
              window.apm.serialized.ccxml = newValue;
              window.apm.serialized.ccxmlLastLocalChange = window.apm.timestamp;
              window.apm.setSerializedChanged();
            }}
            originalValue={(compareSerialized) ? compareSerialized.ccxml ?? '' : undefined}
            value={serialized.ccxml ?? ''}
          />
        </div>
      </div>
    </div>
  );
};
